const setRegQuarter = payload => {
  return {
    type: "regquarter",
    payload
  };
};

export default setRegQuarter;
